import {setDocTemplateRequest} from '../../actions/docTemplates'
import store from '../../store'

export function setDocTemplate(docId,template){
	return store.dispatch(setDocTemplateRequest(docId,template))
}
